/*
 * SQD Athletica redesign: hero height, product carousel, header search and cart.
 */
(function() {
  var root = document.documentElement;

  /* Hero height: fill the screen below the announcement bar and header
     ------------------------------------------------------------------ */
  function setHeroOffset() {
    var hero = document.querySelector('.sqd-hero');
    if (!hero) return;
    var offset = hero.getBoundingClientRect().top + window.scrollY;
    root.style.setProperty('--sqd-hero-offset', Math.max(0, Math.round(offset)) + 'px');
  }

  /* Product carousel
     ------------------------------------------------------------------ */
  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-sqd-carousel]').forEach(function(carousel) {
      if (carousel.sqdCarousel) return;
      carousel.sqdCarousel = true;

      var track = carousel.querySelector('[data-sqd-carousel-track]');
      var prev = carousel.querySelector('[data-sqd-carousel-prev]');
      var next = carousel.querySelector('[data-sqd-carousel-next]');
      if (!track || !prev || !next) return;

      function step() {
        var item = track.querySelector('.sqd-carousel__item');
        if (!item) return track.clientWidth;
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }

      prev.addEventListener('click', function() {
        track.scrollBy({ left: -step() });
      });
      next.addEventListener('click', function() {
        track.scrollBy({ left: step() });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* Header search bar with predictive results
     ------------------------------------------------------------------ */
  function initSearch() {
    document.querySelectorAll('[data-sqd-search]').forEach(function(form) {
      if (form.sqdSearch) return;
      form.sqdSearch = true;

      var input = form.querySelector('input[type="search"]');
      var results = form.querySelector('[data-sqd-search-results]');
      var predictive = form.dataset.predictive === 'true' && window.theme && theme.routes && theme.routes.predictiveSearch;
      if (!input || !results || !predictive) return;

      var timer = null;
      var controller = null;
      var lastQuery = '';

      function close() {
        results.hidden = true;
      }

      function search() {
        var query = input.value.trim();
        if (query.length < 2) {
          lastQuery = '';
          close();
          return;
        }
        if (query === lastQuery) {
          results.hidden = results.innerHTML === '';
          return;
        }
        lastQuery = query;

        if (controller) controller.abort();
        controller = new AbortController();

        var params = new URLSearchParams({
          q: query,
          'resources[type]': (theme.settings && theme.settings.predictiveSearchType) || 'product,collection,page',
          'resources[limit]': 4,
          'resources[options][unavailable_products]': 'last',
          section_id: 'predictive-search'
        });

        fetch(theme.routes.predictiveSearch + '?' + params.toString(), { signal: controller.signal })
          .then(function(response) { return response.text(); })
          .then(function(html) {
            var section = new DOMParser().parseFromString(html, 'text/html').querySelector('#shopify-section-predictive-search');
            var markup = section ? section.innerHTML.trim() : '';
            var searchUrl = theme.routes.search + '?q=' + encodeURIComponent(query) + '&options[prefix]=last';

            results.innerHTML = '';
            if (markup) {
              results.innerHTML = markup;
              var all = document.createElement('a');
              all.className = 'sqd-search__all';
              all.href = searchUrl;
              all.textContent = 'View all results';
              results.appendChild(all);
            } else {
              var empty = document.createElement('p');
              empty.className = 'sqd-search__empty';
              empty.textContent = 'No results for “' + query + '”';
              results.appendChild(empty);
            }
            results.hidden = false;
          })
          .catch(function() {});
      }

      input.addEventListener('input', function() {
        window.clearTimeout(timer);
        timer = window.setTimeout(search, 220);
      });
      input.addEventListener('focus', search);
      input.addEventListener('keydown', function(evt) {
        if (evt.key === 'Escape') {
          close();
          input.blur();
        }
      });
      document.addEventListener('click', function(evt) {
        if (!form.contains(evt.target)) close();
      });
    });
  }

  /* Cart drawer and cart page
     The theme rebuilds [data-products] from the cart.ajax template whenever the cart
     changes. These helpers keep the item count and Afterpay amount in step with it,
     and handle the one-click add ons and the remove (bin) button.
     ------------------------------------------------------------------ */
  function syncCart(products) {
    var items = products.querySelector('.cart__items');
    if (!items) return;

    var form = products.closest('form');
    if (!form) return;

    form.querySelectorAll('[data-sqd-cart-count]').forEach(function(el) {
      el.textContent = items.dataset.count || '0';
    });
    form.querySelectorAll('[data-sqd-afterpay-amount]').forEach(function(el) {
      el.textContent = items.dataset.sqdAfterpay || '';
    });
  }

  function initCart() {
    document.querySelectorAll('#CartDrawerForm [data-products], #CartPageForm [data-products]').forEach(function(products) {
      if (products.sqdCart) return;
      products.sqdCart = true;

      new MutationObserver(function() { syncCart(products); }).observe(products, { childList: true });
      syncCart(products);
    });
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Cart error');
        return data;
      });
    });
  }

  function rebuildCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  document.addEventListener('click', function(evt) {
    var addButton = evt.target.closest('[data-sqd-upsell-add]');
    if (addButton) {
      evt.preventDefault();
      if (addButton.disabled) return;

      var labelEl = addButton.querySelector('[data-sqd-upsell-label]') || addButton;
      var label = labelEl.textContent;
      addButton.disabled = true;
      labelEl.textContent = 'Adding';

      cartRequest(theme.routes.cartAdd, { items: [{ id: Number(addButton.dataset.variantId), quantity: 1 }] })
        .then(function() {
          labelEl.textContent = 'Added';
          rebuildCart();
        })
        .catch(function() {
          addButton.disabled = false;
          labelEl.textContent = label;
        });
      return;
    }

    var removeButton = evt.target.closest('[data-sqd-cart-remove]');
    if (removeButton) {
      evt.preventDefault();
      if (removeButton.classList.contains('is-loading')) return;
      removeButton.classList.add('is-loading');

      cartRequest(theme.routes.cartChange, { id: removeButton.dataset.key, quantity: 0 })
        .then(rebuildCart)
        .catch(function() {
          // Fall back to the plain link if the request fails
          window.location.href = removeButton.href;
        });
    }
  });

  /* Product cards on mobile: swipe the image to switch between its two photos
     ------------------------------------------------------------------ */
  var swipe = null;

  document.addEventListener('touchstart', function(evt) {
    var mask = evt.target.closest ? evt.target.closest('.grid-product') : null;
    swipe = null;
    if (!mask || !mask.querySelector('.sqd-card-dots') || mask.closest('.sqd-carousel, .grid-overflow-wrapper, .sqd-search__results')) return;
    if (!mask.querySelector('.grid__item-image-wrapper').contains(evt.target) && !evt.target.closest('.grid-product__link')) return;

    var touch = evt.touches[0];
    var imageRect = mask.querySelector('.grid-product__image-mask').getBoundingClientRect();
    // Only swipes that start on the image count
    if (touch.clientY < imageRect.top || touch.clientY > imageRect.bottom) return;
    swipe = { card: mask, x: touch.clientX, y: touch.clientY };
  }, { passive: true });

  document.addEventListener('touchend', function(evt) {
    if (!swipe) return;
    var touch = evt.changedTouches[0];
    var dx = touch.clientX - swipe.x;
    var dy = touch.clientY - swipe.y;
    var card = swipe.card;
    swipe = null;

    if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy) * 1.5) return;

    var showSecond = dx < 0;
    card.classList.toggle('is-second', showSecond);
    var dots = card.querySelectorAll('.sqd-card-dots span');
    if (dots.length === 2) {
      dots[0].classList.toggle('is-active', !showSecond);
      dots[1].classList.toggle('is-active', showSecond);
    }
  }, { passive: true });

  /* SEO text: expand and collapse
     ------------------------------------------------------------------ */
  document.addEventListener('click', function(evt) {
    var toggle = evt.target.closest('[data-sqd-seo-toggle]');
    if (!toggle) return;

    var wrapper = toggle.closest('[data-sqd-seo]');
    var expanded = wrapper.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', expanded);
    toggle.textContent = expanded ? toggle.dataset.less : toggle.dataset.more;
  });

  /* Init
     ------------------------------------------------------------------ */
  function init(scope) {
    setHeroOffset();
    initCarousels(scope);
    initSearch();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); });
  } else {
    init();
  }

  window.addEventListener('resize', setHeroOffset);
  window.addEventListener('load', setHeroOffset);

  // Keep the hero height in step with the header as fonts and the logo load
  if ('ResizeObserver' in window) {
    var headerGroup = document.querySelector('.header-sticky-wrapper');
    if (headerGroup) new ResizeObserver(setHeroOffset).observe(headerGroup);
  }

  // Theme editor: sections are re-rendered in place
  document.addEventListener('shopify:section:load', function(evt) { init(evt.target); });
})();
